import { useState, type ReactNode } from 'react';
import styles from './case.module.css';

export type Direction = 'forward' | 'back';

/**
 * Swaps one screen for the next: the old one passes you on its way out while the new one arrives, the way
 * the prototype moves. The old one is drawn again from its step and takes no keys while it leaves.
 */
export function ScreenSwap<Step extends string>({
  step,
  direction,
  render,
}: {
  step: Step;
  direction: Direction;
  render: (step: Step, active: boolean) => ReactNode;
}) {
  const [shown, setShown] = useState(step);
  const [leaving, setLeaving] = useState<{ step: Step; direction: Direction } | null>(null);
  if (shown !== step) {
    setLeaving({ step: shown, direction });
    setShown(step);
  }
  return (
    <div className={styles.stage}>
      {leaving ? (
        <div key={`out-${leaving.step}`} className={styles.leaving} data-direction={leaving.direction} aria-hidden="true" onAnimationEnd={() => setLeaving(null)}>
          {render(leaving.step, false)}
        </div>
      ) : null}
      <div key={step} className={styles.arriving} data-direction={direction}>
        {render(step, true)}
      </div>
    </div>
  );
}
